import { backendUrl } from './../../env-config'
import { authAxios } from './../../helpers/axiosAuthInterceptor'

export interface ReportFilters {
  type: 'coach' | 'participant' | 'all'
  from?: string
  to?: string
  profile?: 'complete' | 'incomplete' | 'any'
  tier?: string
  segment?: string
  search?: string
}

// Drop empty values so the URL (and the audit log) only carries real filters.
const toParams = (filters: ReportFilters, extra: Record<string, string> = {}) =>
  Object.fromEntries(Object.entries({ ...filters, ...extra }).filter(([, v]) => v !== undefined && v !== '' && v !== 'any'))

export const getUserReport = async (filters: ReportFilters, refresh = false) => {
  return await authAxios.get(`${backendUrl}/super-admin/reports/users`, {
    params: toParams(filters, refresh ? { refresh: '1' } : {}),
  })
}

export const downloadUserReportCsv = async (filters: ReportFilters) => {
  const res = await authAxios.get(`${backendUrl}/super-admin/reports/users.csv`, {
    params: toParams(filters),
    responseType: 'blob',
  })
  const disposition: string = res.headers['content-disposition'] || ''
  const filename = /filename="([^"]+)"/.exec(disposition)?.[1] || 'viveka-users.csv'
  const url = URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
